import { AlertType, ApprovedStatus } from '@core/enums';
import { GetRoles, GetUserId } from '@core/utils/local-storage-data.utility';

export function getAlertTypeByApprovedStatusOfEntity(entity: any): AlertType | null {
  if (!entity) {
    // console.log('Entity is required');
    return null;
  }

  const currentUserId = +GetUserId();

  // Check for ownership
  const ownerKeys = ['author', 'organizer', 'organizerId', 'userId'];
  let entityUserId: number | undefined;
  for (const key of ownerKeys) {
    if (entity[key] != null) {
      entityUserId = +entity[key];
      break;
    }
  }
  if (entityUserId !== undefined && entityUserId !== currentUserId && !isUserAdmin()) {
    return null;
  }

  // if (entity?.updatedRecord && entity?.denyById) {
  //   return null;
  // }

  // Validate approvedStatus
  if (entity.approvedStatus === undefined || entity.approvedStatus === null || entity.approvedStatus === '') {
    // console.log('Entity does not have approvedStatus property');
    return null;
  }

  // Check conditions in order
  if ((entity.approvedStatus === ApprovedStatus.UnApproved || entity.approvedStatus === ApprovedStatus.Pending) && !entity.denyReason) {
    return AlertType.WAITING_ADMIN_APPROVAL;
  }

  if (entity.approvedStatus === ApprovedStatus.Rejected || (entity.denyById && entity.denyById !== '') || entity.denyByUser) {
    return AlertType.DENY_BY_ADMIN;
  }

  if ((entity.updatedRecord || entity.updateImageUrl) && !entity.denyById) {
    return AlertType.UPDATE_WAITING_ADMIN_APPROVAL;
  }

  if (entity.approvedStatus === ApprovedStatus.Approved && entity.updatedRecord && (entity.denyById || entity.denyByUser)) {
    return AlertType.DENY_BY_ADMIN;
  }

  return null;
}

// Explicitly check if the user is an admin
function isUserAdmin(): boolean {
  const roles = GetRoles();

  return roles.includes('admin') || roles.includes('Admin');
}
